import React from "react";
import styles from "./EarnedAmount.module.scss";
import { Button, Col, Grid, HStack, Row } from "rsuite";
import WithdrawModal from "../WithdrawModal/WithdrawModal";

export default function EarnedAmount() {
  return (
    <div className={styles["earned__amount"]}>
      <HStack spacing={20} alignItems="flex-start">
        <div>
          <h4>₹25,000</h4>
          <p>Reward Balance</p>
        </div>
      </HStack>

      <div className={styles.card}>
        <Grid fluid>
          <Row gutter={10}>
            <Col xs={24}>
              <h6>Referral Tracking</h6>
            </Col>

            <Col xs={12}>
              <div className={styles.list}>
                <p>20 Users</p>
                <span>User Referred</span>
              </div>
            </Col>

            <Col xs={12}>
              <div className={styles.list}>
                <p>5 Users</p>
                <span>Successful Referral</span>
              </div>
            </Col>

            <Col xs={12}>
              <div className={styles.list}>
                <p>15 Users</p>
                <span>Pending Referral</span>
              </div>
            </Col>

            <Col xs={12}>
              <div className={styles.list}>
                <p>₹1,00,000</p>
                <span>Total Amount Earned </span>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>

      <HStack spacing={5} justifyContent="space-between">
        <Button appearance="ghost">Transaction History</Button>
        {/* <Button appearance="primary">Withdraw Money</Button> */}
        <WithdrawModal />
      </HStack>
    </div>
  );
}

// background: #182BDA;
